<template>
    <div class="default-offer-slider">
        <UISlider
            :id="`offer_${_uid}`"
            :options="swiperOptions"
            :slides="slides"
        >
            <template #default="{slide}">
                <slot
                    name="slide"
                    :slide="slide"
                />
            </template>
            <template #navigation>
                <div class="swiper-navigation">
                    <div
                        slot="button-prev"
                        :class="[
                            'swiper-button-background',
                            'swiper-button-background-prev',
                            `offer-button-prev_${uid}`
                        ]"
                    >
                        <div class="swiper-button-prev" />
                    </div>
                    <div
                        slot="button-next"
                        :class="[
                            'swiper-button-background',
                            'swiper-button-background-next',
                            `offer-button-next_${uid}`,
                        ]"
                    >
                        <div class="swiper-button-next" />
                    </div>
                </div>
            </template>
        </UISlider>
    </div>
</template>

<script>
import {computed, defineComponent} from 'vue';
import {UISlider} from '@cibsite/ui-components-vue2';
import {nanoid} from 'nanoid';

export default defineComponent({
    name: 'DefaultOfferSlider',
    components: {
        UISlider,
    },
    props: {
        slides: {
            type: Array,
            required: true,
        },
        additionalSettings: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props) {
        const uid = nanoid();

        const swiperOptions = computed(() => {
            return {
                speed: 500,
                autoHeight: true,
                navigation: {
                    nextEl: `.offer-button-next_${uid}`,
                    prevEl: `.offer-button-prev_${uid}`,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 'auto',
                        spaceBetween: 8,
                    },
                    999: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },
                },
                ...props.additionalSettings,
            };
        });

        return {
            uid,
            swiperOptions,
        };
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/components/sections/sliders/default-offer-slider';
</style>
